import cn from 'classnames';
import { PropsWithChildren } from 'react';

export const Title = ({ children }: PropsWithChildren) => {
  return (
    <h1
      className={cn(
        'py-0 mt-[10px] mb-[20px] text-[28px] font-medium text-[#282828]',
        'md:mb-[60px] md:text-center',
      )}
    >
      {children}
    </h1>
  );
};
